import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import data from "../../Data/staffData/staffData.json";

export default function TeachingStaff() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Профессорско-преподавательский состав
      </h1>

      <div className="staff-list">
        {data.map((person) => (
          <div className="staff-card" key={person.id}>
            <div className="staff-card__photo">
              <img src={person.photo} alt={person.name} />
            </div>
            <div className="staff-card__info">
              <h2>{person.name}</h2>
              <p>{person.position}</p>
              <Link
                to={`/education/teaching-staff/${person.slug}`}
                className="staff-card__link"
              >
                Подробнее →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
